
function updatePoints(id){ 
    let url=VipApp.config.apiUrl+`/api/shopify/updatePoints`
    jQuery.ajax({
        type: "post",
        headers:JSON.parse(VipApp.config.headers), 
        contentType: 'application/json',     
        url,
        data:JSON.stringify({id}),
        success: function(result)
        {
            console.log("result",result.data);
            console.log("result2",$(".pointsSpan"));
            $(".pointsSpan").each(function(index){
                console.log("index",result.data[index].point);
                $(this).text(result.data[index].point)
            })
        }
    });
}


function postAddPoint(id,activeName){
    let url=VipApp.config.apiUrl+`/api/shopify/postAddPoint`
    jQuery.ajax({
        type: "post",
        headers:VipApp.config.headers, 
        contentType: 'application/json',     
        url,
        data:JSON.stringify({
            id,
            activeName
        }),
        success: function(result)
        {
            console.log("result",result.data);
            console.log("result2",$(".pointsSpan"));
            $(".pointsSpan").each(function(index){
                console.log("index",result.data[index].point);
                $(this).text(result.data[index].point)
            })
        }
    });
}
function postFirstOrderCode(id){
    let url=VipApp.config.apiUrl+`/api/shopify/postFirstOrderCode`
    jQuery.ajax({
        type: "post",
        headers:VipApp.config.headers, 
        contentType: 'application/json',     
        url,
        data:JSON.stringify({id}),
        success: function(result)
        {
            console.log("result",result.data);
            console.log("result2",$(".pointsSpan"));
        }
    });
}
let isAllowedPostDiscountCode = false; 
function postDiscountCode(id,discountType){
    if(!isAllowedPostDiscountCode){
        isAllowedPostDiscountCode=true;
        const buttonElement = event.target.closest('button');
        buttonElement.classList.add('loading');
        let url=VipApp.config.apiUrl+`/api/shopify/postDiscountCode`
        jQuery.ajax({
            type: "post",
            headers:VipApp.config.headers?JSON.parse(VipApp.config.headers):'', 
            contentType: 'application/json',     
            url,
            data:JSON.stringify({
                id,
                discountType
            }),
            success: function(result)
            {
                isAllowedPostDiscountCode=false;
                buttonElement.classList.remove('loading');
                if(result.code==-2){
                    TogglePopup(true,"",'Oops! Looks like you need more credits to redeem this item')
                }else if(result.code!==1){
                    TogglePopup(true,"Sorry~Redemption failed",result.message)
                }else{
                    location.href=VipApp.config.vip_account_url+'?type=5'
                }
            },
            error: function(error){
                isAllowedPostDiscountCode=false;
                buttonElement.classList.remove('loading');
            }
        });
    }
}

function TogglePopup(type,title,content){
    const tipsPopupDom=document.getElementById("tips-popup-section");
    const tipsTitleDom=document.getElementById("tips_popup_title");
    const tipsContentDom=document.getElementById("tips_popup_content");
    if(!title){
        tipsContentDom.style.fontSize="20px";
        tipsContentDom.style.fontWeight="bold";
    }
    tipsPopupDom.style.display = type?"flex":"none";
    tipsTitleDom.innerHTML=title;
    tipsContentDom.innerHTML=content;
}
function showTracking(row) {
    if (row.classList.contains('active')) {
        closeAllTrackingPopups();
        return;
    }
    closeAllTrackingPopups();
    row.classList.add('active');
    const popup = row.querySelector('.tracking-popup');
    popup.style.display = 'block';
    const loading = popup.querySelector('.loading-spinner');
    const content = popup.querySelector('.tracking-content');
    loading.style.display = 'flex';
    content.style.display = 'none';
    content.innerHTML='';
    let url=VipApp.config.apiUrl+`/api/shopify/order/getTrackingInfo?oid=${row.getAttribute('data-orderid')}`;
    jQuery.ajax({
        type: "get",
        headers:JSON.parse(VipApp.config.headers), 
        contentType: 'application/json',     
        url,
        success: function(result)
        {
            if(result.code==1){
                result.data.forEach((item) => {
                    content.innerHTML+=`
                    <div class="tracking-info">
                        <div class="item-id">
                        ${item.trackingInfo[0].number}
                            <p data-text="${item.trackingInfo[0].number}" class="copyText">
                            <svg t="1724664345868" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1604" width="16" height="16" class="icon"><path d="M629.39164 415.032528l-163.616428-163.616428c-7.992021-7.992021-20.947078-7.992021-28.939099 0-7.992021 8.002254-7.992021 20.957311 0 28.949332l128.680754 128.680754-175.548178 0L389.968689 184.082552c0-11.2973-9.168824-20.466124-20.466124-20.466124L21.813818 163.616428c-11.307533 0-20.466124 9.168824-20.466124 20.466124l0 818.08214c0 11.307533 9.15859 20.466124 20.466124 20.466124l593.108273 0c11.307533 0 20.466124-9.15859 20.466124-20.466124L635.388215 429.512311C635.388215 424.078555 633.229039 418.880159 629.39164 415.032528zM594.455967 981.698568l-552.176025 0L42.279942 204.548676l306.756499 0 0 224.963635c0 11.2973 9.15859 20.466124 20.466124 20.466124l224.953402 0L594.455967 981.698568z" p-id="1605" fill="#2c2c2c"></path> <path d="M1023.978511 265.895883l0 572.652382c0 11.307533-9.15859 20.466124-20.466124 20.466124l-307.86167 0c-11.2973 0-20.466124-9.15859-20.466124-20.466124 0-11.2973 9.168824-20.466124 20.466124-20.466124l287.395546 0L983.046263 286.362007l-224.953402 0c-11.307533 0-20.466124-9.168824-20.466124-20.466124L737.626737 40.932248l-306.756499 0 0 75.693959c0 11.307533-9.168824 20.466124-20.466124 20.466124-11.307533 0-20.466124-9.15859-20.466124-20.466124L389.93799 20.466124c0-11.2973 9.15859-20.466124 20.466124-20.466124l347.688747 0c11.2973 0 20.466124 9.168824 20.466124 20.466124l0 224.963635 175.548178 0-128.680754-128.680754c-7.992021-7.992021-7.992021-20.947078 0-28.949332 7.992021-7.992021 20.947078-7.992021 28.939099 0l163.616428 163.626661C1021.819334 255.263731 1023.978511 260.462127 1023.978511 265.895883z" p-id="1606" fill="#2c2c2c"></path></svg> 
                            <small style="margin-left: 5px; display: none;">Copied!</small>
                            </p>
                        </div>
                        <a href="${item.trackingInfo[0].url}" target="_blank" class="track-link">Track Package</a>
                    </div> `
                })
                loading.style.display = 'none';
                content.style.display = 'block';
            }
            document.querySelector('.tracking-info').addEventListener('click', (event) => {
                if (event.target.closest('.copyText')) {
                    event.stopPropagation();
                    const text = event.target.closest('.copyText').dataset.text; // 从data属性获取值
                    copyText(text, event.target.closest('.copyText'));
                }
            });
        },
        error: function(error){
           console.log(error)
        }
    });
  }
  function closeAllTrackingPopups() {
    document.querySelectorAll('.shipping-row.active').forEach(item => {
      item.classList.remove('active');
      const popup = item.querySelector('.tracking-popup');
      if (popup) {
        popup.style.display = 'none';
        popup.querySelector('.loading-spinner').style.display = 'flex';
        popup.querySelector('.tracking-content').style.display = 'none';
        popup.querySelector('.tracking-content').innerHTML = '';
      }
    });
  }
